import produce from 'immer';

const INITIAL_STATE = {
  loading: false,
  data: [],
  page: 1,
  pageSize: 10,
  totalCount: 0,
  totalPages: 0,
  find: null,
  params: {},
};

export default function orgao(state = INITIAL_STATE, action) {
  return produce(state, (draft) => {
    switch (action.type) {
      case '@orgao/FIND_ORGAO':
      case '@orgao/UPDATE_ORGAO':
      case '@orgao/DELETE_ORGAO':
      case '@orgao/STORE_ORGAO':
      case '@orgao/ORGAOS_IN_REQUEST': {
        draft.loading = true;
        break;
      }

      case '@orgao/SUCCESS_REMOVE':
      case '@orgao/FAILED_REQUEST': {
        draft.loading = false;
        break;
      }

      case '@orgao/SUCCESS_IN_REQUEST': {
        draft.loading = false;
        draft.data = action.payload.orgaos;
        draft.page = action.payload.page;
        draft.pageSize = action.payload.pageSize;
        draft.totalCount = action.payload.totalCount;
        draft.totalPages = action.payload.totalPages;
        draft.find = {};
        break;
      }

      case '@orgao/SUCCESS_REQUEST': {
        draft.loading = false;
        draft.find = action.payload.orgao;
        break;
      }

      case '@orgao/RECORD_FILTERING': {
        draft.loading = true;
        draft.params = action.payload.params;
        break;
      }

      case '@orgao/CHANGE_ITEM_FIND': {
        draft.find = action.payload.data;
        break;
      }

      case '@hooks/RESET': {
        draft.data = [];
        draft.page = 1;
        draft.pageSize = 10;
        draft.totalCount = 0;
        draft.totalPages = 0;
        draft.find = null;
        draft.params = {};
        break;
      }

      default:
    }
  });
}
